import { dashboardILAxios, buildAuthenticationHeaders } from './global';

const getPaymentMethods = credentials =>
    dashboardILAxios.get(`/il/api/accounts/${ credentials.accountId }/billing/payment-methods`, {
        ...buildAuthenticationHeaders(credentials)
    });

const getAccountCatalog = credentials =>
    dashboardILAxios.get(`/il/api/accounts/${ credentials.accountId }/billing/catalog?apiSource=unified-portal`, {
        ...buildAuthenticationHeaders(credentials)
    });


export {
    getPaymentMethods,
    getAccountCatalog,
};
